// (function () {
//     'use strict';

//     angular.module("imApp").factory("p2ReleaseNoteEditService", ['$ihttp', function ($ihttp) {
//         let service = {
//             getEdit: function (parms) {
//                 return $ihttp.post({
//                     method: 222,
//                     parameters: parms || {}
//                 });
//             },
//             listReleaseTypeNames: function (parms) {
//                 return $ihttp.post({
//                     method: 223,
//                     parameters: parms || {}
//                 });
//             },
//             saveObj: function (edit) {
//                 return $ihttp.post({
//                     method: 224,
//                     parameters: edit
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
